import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MedicamentosComponent } from './medicamentos.component';
import { NgZorroAntdModule} from '../../ng-zorro-antd/ng-zorro-antd.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { LancamentoMedicamentoComponent } from './lancamento-medicamento/lancamento-medicamento.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ImportacaoExcelComponent } from './importacao-excel/importacao-excel.component';
import { PaginaImportacaoExcelComponent } from './pagina-importacao-excel/pagina-importacao-excel.component';
import { PreviaHistoricoAlteracoesComponent } from './previa-historico-alteracoes/previa-historico-alteracoes.component'


@NgModule({
  declarations: [MedicamentosComponent, LancamentoMedicamentoComponent, ImportacaoExcelComponent, PaginaImportacaoExcelComponent, PreviaHistoricoAlteracoesComponent],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    FormsModule, 
    ReactiveFormsModule,
    NgZorroAntdModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [provideNgxMask()],
})
export class MedicamentosModule { }
